"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealershipNumberWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var DealershipNumberWidget = /** @class */ (function (_super) {
    __extends(DealershipNumberWidget, _super);
    function DealershipNumberWidget(props) {
        var _a, _b, _c, _d, _e, _f;
        var _this = _super.call(this, props) || this;
        _this.inputDebounceTimer = null;
        _this.handleKeyPress = function (event) {
            if (event.key === "Enter") {
                // @ts-ignore
                document.getElementById("input-label").click();
            }
        };
        _this.handleChange = function (event) {
            event.persist();
            var newRetailerNumberValue = event.target.value.trim().toUpperCase();
            _this.setState({
                retailerNumber: newRetailerNumberValue,
                retailerExists: undefined
            });
            _this.validateInternal(event.target.value).then(function (result) {
                _this.setState({ retailerNumberDisabled: !result.valid });
            });
            if (_this.inputDebounceTimer) {
                clearTimeout(_this.inputDebounceTimer);
            }
            if (!newRetailerNumberValue) {
                _this.setState({
                    retailerExists: false,
                    retailerNumberDisabled: true
                });
                _this.props.onStateChange(_this.props.question.interactionField, undefined);
                _this.props.onStateChange("uistate.retailerExists", false);
                return;
            }
            _this.inputDebounceTimer = setTimeout(function () {
                _this.props.interaction.retailerNumber = newRetailerNumberValue;
                _this.executeNativeEvent(event).then(function () {
                    var _a, _b;
                    _this.setState({
                        retailerExists: (_b = (_a = _this.props.engine.getInteraction()) === null || _a === void 0 ? void 0 : _a.uistate) === null || _b === void 0 ? void 0 : _b.retailerExists
                    });
                });
            }, _this.props.question.settings.timeout);
        };
        _this.validate = _this.validate.bind(_this);
        _this.retailerNumberDisabled = _this.retailerNumberDisabled.bind(_this);
        _this.inputLabel = document.getElementById("input-label");
        if (_this.inputLabel) {
            _this.inputLabel.addEventListener("keydown", _this.handleKeyPress.bind(_this));
        }
        var retailerExists = (_c = (_b = (_a = _this.props.interaction) === null || _a === void 0 ? void 0 : _a.uistate) === null || _b === void 0 ? void 0 : _b.retailerExists) !== null && _c !== void 0 ? _c : false;
        var retailerNumber = (_d = _this.bindFromField(_this.props.question.interactionField)) !== null && _d !== void 0 ? _d : "";
        var isEnabled = ((_e = _this.props.interaction) === null || _e === void 0 ? void 0 : _e.retailerNumber) !== undefined
            && ((_f = _this.props.interaction) === null || _f === void 0 ? void 0 : _f.retailerNumber) !== null
            && retailerExists;
        _this.state = {
            retailerNumber: retailerNumber,
            retailerNumberDisabled: !isEnabled,
            retailerExists: retailerExists,
            isInfoSectionOpen: false
        };
        return _this;
    }
    DealershipNumberWidget.prototype.render = function () {
        var _a, _b;
        var htmlLabel = this.getSetting("htmlLabel", "");
        var htmlInfo = this.getSetting("htmlInfo", "");
        var hasWidgetErrors = !!((_b = (_a = this.props.validations[this.props.question.name]) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.length);
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group ".concat(this.getSetting("cssClass", "")), children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: this.props.question.name, children: htmlLabel ? this.renderHtml(htmlLabel) : this.props.question.label }), htmlInfo && this.renderHtml(htmlInfo), (0, jsx_runtime_1.jsxs)("div", { className: "input-group", role: this.getSetting("role", ""), "aria-label": this.getSetting("ariaLabel", ""), children: [this.hasPlaceholder(plugin_journey_1.QuestionWidgetBase.PREFIX_PLACEHOLDER) && ((0, jsx_runtime_1.jsx)("div", { className: "input-group-prepend", children: this.renderPlaceholder(plugin_journey_1.QuestionWidgetBase.PREFIX_PLACEHOLDER) })), this.renderInputField(), this.hasPlaceholder(plugin_journey_1.QuestionWidgetBase.POSTFIX_PLACEHOLDER) && ((0, jsx_runtime_1.jsx)("div", { className: "input-group-append", children: this.renderPlaceholder(plugin_journey_1.QuestionWidgetBase.POSTFIX_PLACEHOLDER) }))] }), this.renderValidationResult(), this.getSetting("validFeedback") && this.isValid() &&
                    (0, jsx_runtime_1.jsx)("div", { className: "valid-feedback d-block", children: this.getSetting("validFeedback") }), !this.state.retailerExists && this.state.retailerNumber && !hasWidgetErrors &&
                    (0, jsx_runtime_1.jsxs)("div", { className: "invalid-feedback d-block", children: [(0, jsx_runtime_1.jsx)("p", { children: "Retailer ID is not recognised." }), (0, jsx_runtime_1.jsx)("p", { children: "Please remove all preceding Zeros from dealer code:" }), (0, jsx_runtime_1.jsx)("p", { children: "e.g. 000123 = 123" }), (0, jsx_runtime_1.jsx)("p", { children: "0004567 = 4567" })] })] }));
    };
    DealershipNumberWidget.prototype.renderInputField = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)("div", { className: "row w-100 m-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "form-group ".concat(this.state.isInfoSectionOpen ? ("info-box inner-content negative-margin") : ""), children: [(0, jsx_runtime_1.jsx)("div", { className: "row w-100 m-0", children: (0, jsx_runtime_1.jsx)("label", { htmlFor: "retailerNumber", className: "mr-2 mb-0", children: "What's your car dealership number?" }) }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex w-100 m-0 align-self-even", children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex flex-column retailer-number-input-label", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "font-weight-light mb-3", children: "You can get your retailer number from the dealer you are buying your car from. Please ensure preceding zeros are removed from dealer code" }) }), (0, jsx_runtime_1.jsx)("input", { onBlur: function (event) { return _this.validate(event); }, onChange: this.handleChange, value: this.state.retailerNumber, type: "text", id: "retailerNumber", maxLength: 5, className: "form-control retailerNumber-input-field ".concat(this.getInputValidationClass()), "aria-label": this.props.question.label, placeholder: "XXXXX", required: false })] }) })] }) }));
    };
    DealershipNumberWidget.prototype.validate = function (event) {
        this.validateInternal(event.target.value);
    };
    ;
    DealershipNumberWidget.prototype.retailerNumberDisabled = function () {
        var _a, _b, _c;
        var isEnabled = ((_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.retailerNumber) !== undefined
            && ((_b = this.props.interaction) === null || _b === void 0 ? void 0 : _b.retailerNumber) !== null
            && ((_c = this.state) === null || _c === void 0 ? void 0 : _c.retailerExists);
        return !isEnabled;
    };
    return DealershipNumberWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.DealershipNumberWidget = DealershipNumberWidget;
//# sourceMappingURL=DealershipNumberWidget.js.map